import { createPosition } from "@shared/common/utils/create";
import shortUUID from "short-uuid";
import type { IFormChoiceNode, PartialNode } from "../type";

const createFormChoiceNode = (
  data?: PartialNode<IFormChoiceNode>
): IFormChoiceNode => {
  return {
    type: "FORM_CHOICE",
    id: shortUUID.generate(),
    pluginData: {
      contentEditorPropSeq: 0,
      contentMeta: [],
    },
    reactions: [],
    position: createPosition(data?.position),

    name: "",

    width: { value: 100, unit: "%" },

    fills: [],

    locked: false,

    strokes: [],
    strokeWeight: 1,
    strokeAlign: "CENTER",
    strokeCap: "SQUARE",
    strokeJoin: "ROUND",
    dashPattern: [],

    visible: true,

    effects: [],
    range: {
      type: "RANGE",
      min: 0,
      max: 2,
    },

    label: "<p>새 항목</p>",
    required: true,
    choiceType: "CHECKBOX",

    ...data,

    items: data?.items
      ? data.items.map((item) => ({
          id: shortUUID.generate(),
          label: "",
          ...item,
        }))
      : [
          {
            id: shortUUID.generate(),
            label: "답변 1",
          },
          {
            id: shortUUID.generate(),
            label: "답변 2",
          },
        ],
  };
};

export default createFormChoiceNode;
